/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExternalEhrDocumentRelationType } from './ExternalEhrDocumentRelationType';
import {
    ExternalEhrDocumentRelationTypeFromJSON,
    ExternalEhrDocumentRelationTypeFromJSONTyped,
    ExternalEhrDocumentRelationTypeToJSON,
} from './ExternalEhrDocumentRelationType';

/**
 * 
 * @export
 * @interface ExternalEhrDocument
 */
export interface ExternalEhrDocument {
    /**
     * 
     * @type {string}
     * @memberof ExternalEhrDocument
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalEhrDocument
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalEhrDocument
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalEhrDocument
     */
    external_ehr_document_id?: string;
    /**
     * 
     * @type {ExternalEhrDocumentRelationType}
     * @memberof ExternalEhrDocument
     */
    relation_type?: ExternalEhrDocumentRelationType;
    /**
     * 
     * @type {string}
     * @memberof ExternalEhrDocument
     */
    relation_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalEhrDocument
     */
    created_at?: string;
}

/**
 * Check if a given object implements the ExternalEhrDocument interface.
 */
export function instanceOfExternalEhrDocument(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExternalEhrDocumentFromJSON(json: any): ExternalEhrDocument {
    return ExternalEhrDocumentFromJSONTyped(json, false);
}

export function ExternalEhrDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEhrDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'external_ehr_document_id': !exists(json, 'external_ehr_document_id') ? undefined : json['external_ehr_document_id'],
        'relation_type': !exists(json, 'relation_type') ? undefined : ExternalEhrDocumentRelationTypeFromJSON(json['relation_type']),
        'relation_id': !exists(json, 'relation_id') ? undefined : json['relation_id'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
    };
}

export function ExternalEhrDocumentToJSON(value?: ExternalEhrDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'type': value.type,
        'external_ehr_document_id': value.external_ehr_document_id,
        'relation_type': ExternalEhrDocumentRelationTypeToJSON(value.relation_type),
        'relation_id': value.relation_id,
        'created_at': value.created_at,
    };
}

